import { gql, useMutation } from '@apollo/client';

import { GET_PROCESSES_WITH_PAGINATION } from './get-processes-with-pagination.hook';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { IHookCallbacks } from '../common.hooks.interfaces';
import { useTranslation } from 'react-i18next';

export const DELETE_PROCESS_BY_ID = gql`
  mutation deleteProcessById($processId: ObjectId!) {
    deleteProcessById(processId: $processId) {
      _id
    }
  }
`;

export const useDeleteProcessById = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation('employee');
  const [deleteProcessById] = useMutation(DELETE_PROCESS_BY_ID, {
    onCompleted: data => {
      onSuccess();
      if (data?.deleteProcessById?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('process.notifications.deletedSuccessfully'),
        });
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: t('settings:userProfileSettings.error.title'),
        description: error,
      });
    },
    refetchQueries: [GET_PROCESSES_WITH_PAGINATION],
  });

  return { deleteProcessById };
};
